/* eslint-disable @typescript-eslint/no-empty-function */
import { catchError, map, tap } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AnalysesService } from 'src/app/analyses/services/analyses.service';
import {
  AnalysesTypesLowercase,
  AnalysesTypes,
  DnaReportAnalysis,
} from 'src/app/analyses/interfaces/analyses.types';

import { Report } from 'src/app/core/interfaces/results.types';
import { ResultsService } from 'src/app/core/services/results.service';
import { SemanticTypeValue } from 'src/app/shared/constants/semantic-type';

@Component({
  selector: 'app-results-view',
  templateUrl: './results-view.component.html',
})
export class ResultsViewComponent implements OnInit {
  public readonly AnalysesTypesLowercase = AnalysesTypesLowercase;
  public readonly AnalysesTypes = AnalysesTypes;
  report$: Observable<Report>;
  analyses$: Observable<unknown>;
  type: string;
  id: string;
  error = null;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly resultsService: ResultsService,
    private readonly analysesService: AnalysesService
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.type = this.route.snapshot.data?.type;
      this.id = params.get('id');

      this.report$ = this.resultsService.get(this.id, this.type).pipe(
        map((report) => {
          if (this.type === AnalysesTypesLowercase.Blood) {
            const reportSorted = {
              ...report,
              analyses: this.sortAnalyses(report),
            };
            return reportSorted;
          }
          return report;
        }),
        catchError((error) => {
          this.error = error;
          return of(null);
        }),
        tap((report) => {
          // Log user has viewed this report
          this.resultsService.logViewed(report?.id, this.type).subscribe(
            () => {},
            () => {} // Catch error, can fail for older results
          );
        })
      );
      if (this.type == AnalysesTypesLowercase.DNA) {
        this.analyses$ = this.analysesService
          .getDnaReportAnalyses(this.id)
          .pipe(
            map((analyses: DnaReportAnalysis[]) =>
              this.analysesService.sortDnaBySemanticType(analyses)
            ),
            map((analyses) =>
              this.analysesService.hideAnalysesWithoutResults(analyses)
            )
          );
      }
    });
  }

  sortAnalyses(report) {
    // Sort analyses by semanticValue -> shortName
    const sortByName = (a, b) =>
      a.name.toLowerCase().localeCompare(b.name.toLowerCase());

    const sorted = report.analyses.sort((a, b) => {
      const typeA = SemanticTypeValue[a.semanticType];
      const typeB = SemanticTypeValue[b.semanticType];
      return typeA === typeB ? sortByName(a, b) : typeA - typeB;
    });

    return sorted;
  }
}
